import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "@material-ui/core";
import OverflowTooltip from "../../../../components/OverflowTooltip/OverflowTooltip";
import { ReactComponent as DocumentInsideCircle } from "../../../../assets/svg/document-inside-circle.svg";
import { ReactComponent as ImageInsideCircle } from "../../../../assets/svg/image-inside-circle.svg";
import { ReactComponent as FileInsideCircle } from "../../../../assets/svg/file-inside-circle.svg";
import { isFileTypeImage, urlNormalizer } from "../../../../helpers";
import { IProgramDetailFileBackEndModel } from "../../types";
import { IconWithText } from "../IconWithText";

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 16,
    border: "1px solid #C5C5C5",
    borderRadius: 15,
    padding: "16px 32px",
  },
  container: {
    marginTop: 2,
    display: "flex",
    flexWrap: "wrap",
    gap: "16px 16px",
  },
  extraDocContainer: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #C5C5C5",
    borderRadius: 15,
    padding: 7,
    "&:hover": {
      boxShadow: "0px 0px 8px #C2C9D6B3",
      cursor: "pointer",
    },
  },
  extraDocTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: "#231F20",
    width: 115,
    marginLeft: 8,
  },
}));

interface ExtraDocumentsShowProps {
  extraDocuments: IProgramDetailFileBackEndModel[];
  title?: string;
}

interface ExtraDocumentProps {
  extraDocument: IProgramDetailFileBackEndModel;
}

const ExtraDocument: FC<ExtraDocumentProps> = ({ extraDocument }) => {
  const classes = useStyles();

  return (
    <Link
      underline="none"
      href={urlNormalizer(extraDocument.path)}
      target="_blank"
    >
      <div className={classes.extraDocContainer}>
        {isFileTypeImage(extraDocument.path) ? (
          <ImageInsideCircle />
        ) : (
          <DocumentInsideCircle />
        )}
        <span className={classes.extraDocTitle}>
          <OverflowTooltip text={extraDocument.name} />
        </span>
      </div>
    </Link>
  );
};

export const ExtraDocumentsWidget: FC<ExtraDocumentsShowProps> = ({
  extraDocuments,
  title = "Extra Documents",
}) => {
  const classes = useStyles();

  return (
    <div>
      <IconWithText Icon={FileInsideCircle} title={title} />
      <div className={classes.root}>
        <div className={classes.container}>
          {extraDocuments.map((extraDocument) => (
            <ExtraDocument
              key={extraDocument.name}
              extraDocument={extraDocument}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
